import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ProductionDetailPage } from './production-detail.page';
import { ProductionTableComponent } from './production-table/production-table.component';
export * from './production-detail.page';

const routes: Routes = [
    {
        path: '',
        component: ProductionDetailPage,
    },
];

@NgModule({
    declarations: [ ProductionDetailPage, ProductionTableComponent ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        MatProgressBarModule,
        MatCardModule,
        MatTableModule,
        MatSortModule,
        TranslateModule,
        MatDividerModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
    ],
    providers: [
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    ],
})
export class ProductionDetailPageModule {
}
